import html2pdf from 'html2pdf.js'

/*
Uses https://www.npmjs.com/package/html2pdf.js/v/0.9.1
- Add ref to parent element to generate pdf from content
- If targeting a component - add ref to wrapping div
- Styles must be defined in <style> block within component in order to
  apply to pdf. Vuetify classes in <template> WILL NOT RENDER. This includes font-family etc.
- See documentation for pagebreak options
*/

interface PdfOptions {
  filename: string
  source: Object
  format?: number[]
  orientation?: string
  pagebreak?: Object
}

export async function generatePdfFromHtml(options: PdfOptions) {
  await html2pdf()
    .set({
      margin: 0.25,
      filename: options.filename,
      image: {
        type: 'jpeg',
        quality: 1,
      },
      html2canvas: {
        y: 0,
        scrollY: 0,
        removeContainer: true,
      },
      pagebreak: options.pagebreak || { mode: 'avoid-all' },
      jsPDF: {
        unit: 'in',
        format: options.format || [8.25, 11.75],
        orientation: options.orientation || 'landscape',
      },
    })
    .from(options.source)
    .save()
}
